import {injectConfigData} from './app-data-config-injection.middleware';
import {fsaErrorLogger} from './errors.middleware';
import { isPromise } from '../../utils/utils';

export function errorMiddleware() {
  return (next) => (action) => {
    if (!isPromise(action.payload)) {
      return next(action);
    }

    return next(action).catch((error) => {
      console.error('Error:', error);
      return error;
    });
  };
}

//eslint-disable-next-line
export default [errorMiddleware, fsaErrorLogger, injectConfigData];
